// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__rUi5-","location":"Header_location__2MPSG"};